import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { IssueDto } from "./issue.dto";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { HttpRequest } from "@/core/common/http/http-request";
import { IRequest } from "@/interfaces/IRequest";
import { plainToInstance } from "class-transformer";
import { FindManyResult } from "@/core/common/resource-base/find-many-result.dto";
import { CreateIssueDto } from "./create-issue.dto";
import { UpdateIssueDto } from "./update-issue.dto";
import { IssueStatusEnum } from "@altertec_gparn/lib";
import { CreateFileDto } from "@/core/features/file/create-file.dto";

export class IssuesResource extends ResourceBaseService<IssueDto, CreateIssueDto, UpdateIssueDto> {
  protected EntityDto = IssueDto;
  protected CreateEntityDto = CreateIssueDto;
  protected UpdateEntityDto = UpdateIssueDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/issues");
  }

  getMine(request: IRequest = {}): Promise<FindManyResult<IssueDto>> {
    return this.apiHttpClient
      .request<IssueDto, FindManyResult<IssueDto>>(
        HttpRequest.create({
          url: this.resourceUrl,
          method: "GET",
          auth: true,
          query: this.getQueryBuilder(request).query(),
        })
      )
      .then((findManyResult: FindManyResult<IssueDto>) => {
        findManyResult.data = plainToInstance(IssueDto, findManyResult.data);
        return findManyResult;
      });
  }

  updateStatus(id: string, status: IssueStatusEnum): Promise<IssueDto> {
    return this.apiHttpClient
      .request<{ status: IssueStatusEnum }, IssueDto>(
        HttpRequest.create({
          url: this.resourceUrl + "/" + id + "/status",
          method: "PATCH",
          auth: true,
          body: { status },
        })
      )
      .then((result: IssueDto) => {
        return plainToInstance(IssueDto, result);
      });
  }

  createManyAttachments(id: string, files: CreateFileDto[]): Promise<IssueDto> {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/attachments",
        method: "POST",
        auth: true,
        body: { bulk: files },
      })
    );
  }

  deleteAttachment(id: string, fileId: string): Promise<IssueDto> {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/attachments",
        method: "DELETE",
        auth: true,
        body: { id: fileId },
      })
    );
  }
}
